module.exports = __webpack_public_path__ + "staticcomp/img/aboutme_qrcode.55adc47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutme_qrcode.jpg
// module id = kR7+
// module chunks = 39